import { Navigate } from "react-router-dom";
import { useSelector } from 'react-redux';

export const ProtectedRoute = ({ children }) => {
  const authenticationStatus = useSelector(state => state.auth.authenticationStatus);
  if (authenticationStatus === true){
    return children
  }
  else{
    return <Navigate to="/" />;
  }
};